// extracted by mini-css-extract-plugin
export default {"mCard":"Mt-z","image":"Nt-z","imageNoBackground":"Ot-z","fullWidth":"Pt-z"};